// extracted by mini-css-extract-plugin
export var hero = "style-module--hero--df5d3";
export var heroContainer = "style-module--hero-container--588e1";
export var heroContent = "style-module--hero-content--3d0d7";
export var inheritColor = "style-module--inherit-color--f7ca5";
export var scrollButton = "style-module--scroll-button--a1770";